// Requires: src/namespace.js

window.BOL.RegisterProduct.ErrorManager = (function($, sectionManager) {
	'use strict';

	function ErrorManager(SELECTORS, DATA_ATTTIBUTES) {
		var defaultErrors = {};

		var $error_container 	= $('[' + SELECTORS.errorCode + ']');
		var $container    		= $('[' + SELECTORS.container + ']');
		var $message      		= $(SELECTORS.message);

	    function showError(message) {
	        message = (message ? message : defaultErrors.message);

	        $message.html(message);
	        $container.attr(SELECTORS.container, false);

	        var $error_Message = $("[error-code='" + message + "']");
	        var $error_MessageDefault = $("[error-code='default']");

	        // Intercept 405 / 406 response (Purchase Date response), else, use standard response
	        if (message === "405" || message === "406") {
	            var purchaseDateMessage = $error_Message.find($message).attr("data-dateField-form-error-message");
	            $message.html(purchaseDateMessage);
	            $error_Message.attr(SELECTORS.container, false);
	            $error_Message.show();
	            // Else if 'default' or another error code
	        } else if (message === "default" || (message !== null && message.length > 0)) {
	            var purchaseDateMessageDefault =
	                $error_MessageDefault.find($message).attr("data-dateField-form-error-message");
	            $message.html(purchaseDateMessageDefault);
	            $error_MessageDefault.attr(SELECTORS.container, false);
	            $error_MessageDefault.show();
	        } else {
	            $error_Message.attr(SELECTORS.container, false);
	            $error_Message.show();
	        }
	    }

	    function setDefaultErrors() {
			defaultErrors.message = $message.data(DATA_ATTTIBUTES.message);
		}

		function hideError() {
			$container.attr(SELECTORS.container, true);
		}

		return {
			init:      setDefaultErrors,
			showError: showError,
			hideError: hideError
		};
	}

	return {
		create: ErrorManager
	};

})($jq);